// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import PostFeedbackRequestModel from '../../model/post-feedback-request-model';
import PutFeedbackRequestModel from '../../model/put-feedback-request-model';
import GetCompanyFeedbacksRequestModel from '../../model/get-company-feedbacks-request-model';
import GetFeedbackByOrganisationIdRequestModel from '../../model/get-feedback-by-organisation-id-request-model';
import GetFeedbackByCompanyIdRequestModel from '../../model/get-feedback-by-company-id-request-model';
import PostExcelForAdminRequestModel from '../../model/post-excel-for-admin-request-model';
import PostExcelForOrganisationRequestModel from '../../model/post-excel-for-organisation-request-model';
import Tdg_FeedbackModel from '../../model/tdg-feedback-model';
import Tdg_FeedbackListPagingResultModel from '../../model/tdg-feedback-list-paging-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async postFeedback(request: PostFeedbackRequestModel, config?: RequestConfig) {
    const requestDTO = PostFeedbackRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-feedback'] ?? 'tdg/admin/feedbacks';
    const response = await service.post<any>(endpointPath, {
      body: {
        companyId: requestDTO.companyId,
        eventRating: requestDTO.eventRating,
        reparticipationRating: requestDTO.reparticipationRating,
        youthVisitorsCount: requestDTO.youthVisitorsCount,
        adultVisitorsCount: requestDTO.adultVisitorsCount,
        remark: requestDTO.remark,
      },
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_FeedbackModel.toModel(dto));
  },
  /**  */
  async putFeedback(request: PutFeedbackRequestModel, config?: RequestConfig) {
    const requestDTO = PutFeedbackRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-put-feedback'] ?? 'tdg/admin/feedbacks/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        companyId: requestDTO.companyId,
        eventRating: requestDTO.eventRating,
        reparticipationRating: requestDTO.reparticipationRating,
        youthVisitorsCount: requestDTO.youthVisitorsCount,
        adultVisitorsCount: requestDTO.adultVisitorsCount,
        remark: requestDTO.remark,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async getCompanyFeedbacks(request: GetCompanyFeedbacksRequestModel, config?: RequestConfig) {
    const requestDTO = GetCompanyFeedbacksRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-company-feedbacks'] ?? 'tdg/admin/feedbacks/admin';
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_FeedbackListPagingResultModel.toModel(dto));
  },
  /**  */
  async getFeedbackByOrganisationId(request: GetFeedbackByOrganisationIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetFeedbackByOrganisationIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-feedback-by-organisation-id'] ?? 'tdg/admin/feedbacks/organisation/{organisationId}';
    endpointPath = endpointPath.replace(/\{organisationId\}/g, `${requestDTO.organisationId}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_FeedbackListPagingResultModel.toModel(dto));
  },
  /**  */
  async getFeedbackByCompanyId(request: GetFeedbackByCompanyIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetFeedbackByCompanyIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-feedback-by-company-id'] ?? 'tdg/admin/feedbacks/company/{companyId}';
    endpointPath = endpointPath.replace(/\{companyId\}/g, `${requestDTO.companyId}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_FeedbackListPagingResultModel.toModel(dto));
  },
  /**  */
  async postExcelForAdmin(request: PostExcelForAdminRequestModel, config?: RequestConfig) {
    const requestDTO = PostExcelForAdminRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-excel-for-admin'] ?? 'tdg/admin/feedbacks/ExcelForAdmin';
    const response = await service.post<any>(endpointPath, {
      responseType: 'blob',
      body: {
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        paging: requestDTO.paging,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
      },
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
  /**  */
  async postExcelForOrganisation(request: PostExcelForOrganisationRequestModel, config?: RequestConfig) {
    const requestDTO = PostExcelForOrganisationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-excel-for-organisation'] ?? 'tdg/admin/feedbacks/ExcelForOrganisation';
    const response = await service.post<any>(endpointPath, {
      responseType: 'blob',
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        organisationId: requestDTO.organisationId,
        selectedOrganisationId: requestDTO.selectedOrganisationId,
        selectedEventId: requestDTO.selectedEventId,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(new Blob([result], { type: 'application/octet-stream' }));
  },
});
